import type { EventFacetKey, EventLibraryItem } from "@friends-church-dvr/contracts";

export const isFacetInitiallyOpen = (_key: EventFacetKey): boolean => false;

export const groupUpNextAndPast = (
  events: EventLibraryItem[],
  now = Date.now(),
): { upNext: EventLibraryItem[]; past: EventLibraryItem[] } => ({
  upNext: events
    .filter((event) => Date.parse(event.scheduledEndAt) >= now)
    .sort((left, right) => Date.parse(left.scheduledStartAt) - Date.parse(right.scheduledStartAt)),
  past: events
    .filter((event) => Date.parse(event.scheduledEndAt) < now)
    .sort((left, right) => Date.parse(right.scheduledStartAt) - Date.parse(left.scheduledStartAt)),
});

export const groupEventsByServiceType = (
  events: EventLibraryItem[],
): Array<{ serviceTypeId: string; serviceTypeName: string; events: EventLibraryItem[] }> => {
  const groups = new Map<string, { serviceTypeId: string; serviceTypeName: string; events: EventLibraryItem[] }>();
  for (const event of events) {
    const group = groups.get(event.serviceTypeId) ?? {
      serviceTypeId: event.serviceTypeId,
      serviceTypeName: event.serviceTypeName,
      events: [],
    };
    group.events.push(event);
    groups.set(event.serviceTypeId, group);
  }
  return [...groups.values()].sort((left, right) => {
    const newestLeft = Math.max(...left.events.map((event) => Date.parse(event.scheduledStartAt)));
    const newestRight = Math.max(...right.events.map((event) => Date.parse(event.scheduledStartAt)));
    return newestRight - newestLeft || left.serviceTypeName.localeCompare(right.serviceTypeName, "en", { sensitivity: "base" });
  });
};
